<template>
  <div class="tipresult">
    <h1>举报奖励</h1>
    <p>尊敬的顾客：<br />感谢您提供的信息，这些信息一旦确认，我们将提供一条**香烟予以感谢。</p>
    <div class="footer">
      <button @click="back">返回举报界面</button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    back: function () {
      this.$router.push("/tip");
    }
  }
}
</script>

<style lang="stylus" scoped>
.tipresult {
  color: #231815;

  h1 {
    font-size: 0.652778rem;
    text-align: center;
    margin: 1.527778rem auto;
  }

  p {
    font-size: 0.430556rem;
    font-weight: 400;
    line-height: 0.722222rem;
    width: 8rem;
    margin: 0 auto;
  }

  .footer {
    position: fixed;
    bottom: 1.388889rem;
    width: 100%;
    text-align: center;

    button {
      border: none;
      background: transparent;
      color: #1B92D2;
      font-size: 0.5rem;
      border-bottom: 1px solid #1B92D2;
      padding: 0.138889rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/example01/tipresult.vue